import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Loading from './Loading'
import Private from './PrivateInfo'
import Pro from './ProInfo'
import Subscribe from './SubscribeInfo'

class InfoMember extends React.Component {


  render (){
    return (
        <Container  className='shadow' style={{backgroundColor: 'white', padding: 15, borderRadius: 5, marginTop: 30, marginBottom: 10}}>


          <Row >
          {
            this.props.loading ?
            <Loading size={50} loadingMore={this.props.loading}/>
            :
            <>
            <Private Private={this.props.Private}/>
            <Pro SocietyInfo={this.props.SocietyInfo} Pro={this.props.Pro} />
            <Subscribe  Private={this.props.Private} intl={this.props.intl} Complement={this.props.Complement}/>
            </>

          }


          </Row>

        </Container>

    )
  }
}

export default InfoMember;
